"use strict";
/**
 * @module Services.GatewayControl
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../../io/codec");
var serialiser_1 = require("./../../../serialisers/serialiser");
/**
 * Serialiser for {@link GatewayServiceType}
 */
var GatewayServiceTypeSerialiserClass = /** @class */ (function (_super) {
    __extends(GatewayServiceTypeSerialiserClass, _super);
    function GatewayServiceTypeSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link GatewayServiceType} from the stream
     *
     * @param bis the input stream
     * @return    the {@link GatewayServiceType} that was read
     */
    GatewayServiceTypeSerialiserClass.prototype.read = function (bis) {
        var name = Codec.readString(bis);
        var desc = Codec.readString(bis);
        var schema = Codec.readString(bis);
        return {
            name: name,
            description: desc,
            schema: schema
        };
    };
    /**
     * Write a {@link GatewayServiceId} from the stream
     *
     * @param bos   the output stream
     * @param value the {@link GatewayServiceId} to write
     */
    GatewayServiceTypeSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.name);
        Codec.writeString(bos, value.description);
        Codec.writeString(bos, value.schema);
    };
    return GatewayServiceTypeSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.GatewayServiceTypeSerialiserClass = GatewayServiceTypeSerialiserClass;
/**
 * The {@link GatewayServiceTypeSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.GatewayServiceTypeSerialiser = new GatewayServiceTypeSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/services/service-type-serialiser.js
// module id = 1329
// module chunks = 1